import React from "react";

import { Grid, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Currency } from "../../../models/currency";
import { formatCurrency } from "../../../util/prices";
import {
  Wrapper,
  Header,
  Title,
  SubTitle,
  Columns,
  ColumnTitle,
  Content,
  ContentRow,
  Footer,
} from "./styled";

type MaterialCount = {
  name: string;
  quantity: number;
  price?: number;
};

interface MaterialBoxProps {
  title: string;
  materials: MaterialCount[];
  destination: string;
  titleColor?: string;
  currency?: Currency;
}

export const MaterialBox = (props: MaterialBoxProps) => {
  const { title, materials, destination, titleColor, currency } = props;
  const { t: translate } = useTranslation();

  const onGetMaterialPrices = () => {
    let materialPrices: number = 0;

    materials?.forEach((material) => {
      materialPrices += material.quantity * Number(material.price);
    });

    return materialPrices;
  };

  return (
    <Wrapper container direction="column">
      <Header>
        <Grid item>
          <Title item color={titleColor}>
            <span>{title}</span>
          </Title>
          <SubTitle item>
            <span>{destination}</span>
          </SubTitle>
        </Grid>
      </Header>

      <Columns container direction="row">
        <ColumnTitle item width="50%">
          <span>{translate("material")}</span>
        </ColumnTitle>
        <ColumnTitle item width="25%">
          <span>{translate("qty")}</span>
        </ColumnTitle>
        <ColumnTitle item width="25%">
          <span>{translate("price")}</span>
        </ColumnTitle>
      </Columns>

      <Content container>
        {materials.map((material, index: number) => {
          return (
            <Grid container direction="row" key={`material-count-${index}`}>
              <ContentRow item width="50%">
                <Tooltip title={material.name ?? ""} placement="top">
                  <span>{material.name}</span>
                </Tooltip>
              </ContentRow>
              <ContentRow item width="25%">
                <span>{material.quantity}</span>
              </ContentRow>
              <ContentRow item width="25%">
                <span>{formatCurrency(material.price ?? 0, currency)}</span>
              </ContentRow>
            </Grid>
          );
        })}
      </Content>

      <Footer container direction="row">
        <ColumnTitle item width="50%">
          <span>{translate("total")}</span>
        </ColumnTitle>
        <ColumnTitle item width="25%">
          <span>
            {materials.reduce((a, material: MaterialCount) => a + Number(material.quantity), 0)}
          </span>
        </ColumnTitle>
        <ColumnTitle item width="25%">
          <span>{formatCurrency(onGetMaterialPrices(), currency)}</span>
        </ColumnTitle>
      </Footer>
    </Wrapper>
  );
};
